import React from 'react';
import './Conquistas.css';

import selo1 from "../../assets/img/Certificada Mental Health.jpg";
import selo2 from "../../assets/img/SeloGPTW2026.png";
import selo3 from "../../assets/img/Selo Minas Gerais 2025.png";
import selo4 from "../../assets/img/Selo ISO 31000.png";
import selo5 from "../../assets/img/SeloGov.webp";
import selo6 from "../../assets/img/Selo Governanca.webp";

interface Selo {
  image: string;
  alt: string;
  link?: string;
}

const selos: Selo[] = [
  {
    image: selo1,
    alt: 'Certificada Mental Health',
    link: '#'
  },
  {
    image: selo2,
    alt: 'Selo GPTW 2026',
    link: '#'
  },
  {
    image: selo3,
    alt: 'Selo Minas Gerais 2025',
    link: '#'    
  },
  {
    image: selo4,
    alt: 'Selo ISO 31000',
    link: '#'
  },
  {
    image: selo5,
    alt: 'Selo Governança de Investimentos',
    link: '#'
  },
  {
    image: selo6,
    alt: 'Selo Governança Corporativa',
    link: '#'
  }, 
];

const Conquistas: React.FC = () => {
  return (
    <section className="conquistas-container">
      <div className="conquistas-content">
        <div className="conquistas-left">
          <h2>
            <span>Nossas</span><br />
            <span>conquistas</span>
          </h2>
        </div>
        <div className="conquistas-right">
          <div className="selos-grid">
            {selos.map((selo, idx) => (
              <div className={`selo-item${selo.alt.includes('ISO 31000') || selo.alt.includes('Bureau') ? ' selo-bureau' : ''}`} key={idx}>
                {selo.link ? (
                  // <a href={selo.link} target="_blank" rel="noopener noreferrer">
                    <img src={selo.image} alt={selo.alt} />
                  // </a>
                ) : (
                  <img src={selo.image} alt={selo.alt} />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conquistas;